import React from "react";
import './Results.css';

const CreateTerm = () => {
  return (
    <>
        <h2>Create Term</h2><br />
        <div className="practicals"></div>
      </>
  );
};

export default CreateTerm;
